"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createFormatIngressTagsMiddleware = function () {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var formatIngressTagsMiddleware = function () { return function (next) { return function (activity) {
        var patchedActivity = JSON.parse(JSON.stringify(activity));
        if (patchedActivity) {
            if (patchedActivity.channelData && patchedActivity.channelData.tags) {
                var tags = patchedActivity.channelData.tags;
                if (typeof tags === 'string') {
                    try {
                        patchedActivity.channelData.tags = JSON.parse(tags); // Attempt to parse tags in JSON format
                    }
                    catch (_a) {
                        patchedActivity.channelData.tags = tags.split(','); // Convert string to array
                    }
                }
            }
        }
        return next(patchedActivity);
    }; }; };
    return formatIngressTagsMiddleware;
};
exports.default = createFormatIngressTagsMiddleware;
//# sourceMappingURL=createFormatIngressTagsMiddleware.js.map